import { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handleDemoClick = () => {
    setIsVideoPlaying(true);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary/5 via-background to-secondary/5">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent" />
        <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-accent/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="inline-flex items-center px-4 py-2 bg-primary/10 rounded-full">
                <Icon name="Sparkles" size={16} className="text-primary mr-2" />
                <span className="text-sm font-medium text-primary">AI-Powered Intelligence Platform</span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                Transform Vision into
                <span className="block text-primary mt-2">Intelligence</span>
              </h1>

              <p className="text-lg md:text-xl text-text-secondary leading-relaxed">
                Convert passive surveillance into strategic business intelligence. Make data-driven decisions from every frame with AI-powered analytics that never sleep.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Play"
                  iconPosition="left"
                  onClick={handleDemoClick}
                  className="animate-pulse-subtle">

                  Watch Live Demo
                </Button>
                {/* <Button
                  variant="outline"
                  size="lg"
                  iconName="Calculator"
                  iconPosition="left">

                  Calculate Your ROI
                </Button> */}
              </div>

              <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border">
                <div>
                  <div className="text-3xl font-bold text-primary">99.8%</div>
                  <div className="text-sm text-text-secondary mt-1">Accuracy Rate</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-primary">24/7</div>
                  <div className="text-sm text-text-secondary mt-1">Real-time Analysis</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-primary">50+</div>
                  <div className="text-sm text-text-secondary mt-1">Analytics Features</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-brand-lg bg-card">
                {!isVideoPlaying ?
                <div className="relative aspect-video">
                    <Image
                    src="https://img.rocket.new/generatedImages/rocket_gen_img_17771b7af-1764487579006.png"
                    alt="Modern analytics dashboard displaying real-time video surveillance data with AI-powered insights and metrics on multiple screens"
                    className="w-full h-full object-cover" />

                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-center justify-center">
                      <button
                      onClick={handleDemoClick}
                      className="w-20 h-20 bg-primary rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300"
                      aria-label="Play demo video">

                        <Icon name="Play" size={32} className="text-primary-foreground ml-1" />
                      </button>
                    </div>
                  </div> :

                <div className="aspect-video bg-black flex items-center justify-center">
                    <div className="text-center space-y-4">
                      <Icon name="Video" size={48} className="text-primary mx-auto" />
                      <p className="text-white">Demo video currently not available</p>
                    </div>
                  </div>
                }
              </div>

              <div className="absolute -bottom-6 -right-6 bg-success text-success-foreground px-6 py-4 rounded-xl shadow-brand-lg">
                <div className="flex items-center gap-3">
                  <Icon name="TrendingUp" size={24} />
                  <div>
                    <div className="text-2xl font-bold">40%</div>
                    <div className="text-sm opacity-90">Average ROI Increase</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;